import "../../css/status-badge.css";

export const StatusBadge = ({ status }: { status: string }) => {
  const isActive = status === "ACTIVO";
  return (
    <span
      className={`status-badge ${isActive ? "status-badge--active" : "status-badge--inactive"}`}
    >
      <span className="status-badge__dot" />
      {status}
    </span>
  );
};
